import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import Cookies from "js-cookie";
import { ROUTE_PATHS } from "../../constants/routeConstants";

const baseUrl = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";

const rawBaseQuery = fetchBaseQuery({
  baseUrl,
  prepareHeaders: (headers) => {
    const token = Cookies.get("token");
    if (token) {
      headers.set("Authorization", `Bearer ${token??''}`);
    }
    return headers;
  },
});

const baseQuery = async (args, api, extraOptions) => {
  const result = await rawBaseQuery(args, api, extraOptions);

  // Session expired: a 401 on an admin page → clear token and bounce to admin login.
  if (result?.error?.status === 401) {
    const { pathname } = window.location;
    if (pathname.startsWith("/admin") && pathname !== ROUTE_PATHS.LOGIN) {
      Cookies.remove("token");
      window.location.href = ROUTE_PATHS.LOGIN;
    }
  }

  if (result?.data && typeof result.data === "object" && "data" in result.data) {
    return { ...result, data: result.data.data };
  }
  return result;
};

export const baseApi = createApi({
  reducerPath: "api",
  baseQuery,
  tagTypes: [
    "User",
    "Role",
    "Permission",
    "Brand",
    "Category",
    "SubCategory",
    "Product",
    "BlogCategory",
    "Blog",
    "Banner",
    "ContactSetting",
    "ContactMessage",
    "WebsiteSetting",
    "SmtpConfig",
    "SocialLink",
    "PageMeta",
    "Subscriber",
    "Page",
    "Review",
  ],
  endpoints: () => ({}),
});
